// shared/hooks/useCompanyDecision.ts
import { useEffect, useRef } from 'react'
import { Company } from 'resources/types'


export function useCompanyDecision({
	fbUser, memberships, membershipsFetched, membershipsLoading, companiesFetched, companiesLoading, companies, openPicker, autoSelect, onEmpty,
}: {
	fbUser: { emailVerified: boolean } | undefined | null
	memberships: { companyId: string }[] | undefined
	membershipsFetched: boolean
	membershipsLoading: boolean
	companiesFetched: boolean
	companiesLoading: boolean
	companies: Company[] | undefined
	openPicker: () => void
	autoSelect: (company: Company) => void
	onEmpty: () => void
}) {
	const decidedRef = useRef(false)
	useEffect(() => {
		if (decidedRef.current) return
		if (!membershipsFetched || membershipsLoading) return
		if (!fbUser?.emailVerified) return
		if (!companiesFetched || companiesLoading) return
		if (!memberships) return
		const ids = memberships.map(m => m.companyId)
		if (ids.length === 0) return
		if (!companies) return

		decidedRef.current = true
		if (companies.length === 0) return onEmpty()
		if (companies.length === 1) return autoSelect(companies[0])
		openPicker()
	}, [fbUser, memberships, companies, openPicker, autoSelect, onEmpty])
}
